import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { PointerGesturesDirective } from '@workbuddy/ui/v2/directives/pointer.gestures';
import { KanbanColumnComponent } from '../column/kanban.column.component';
import { KanbanHost, KanbanSwimlane } from '../model/kanban.model';

@Component({
  selector: 'kanban-swimlane',
  templateUrl: 'kanban.swimlane.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, KanbanColumnComponent, PointerGesturesDirective]
})
export class KanbanSwimlaneComponent {
  public readonly $host = input.required<KanbanHost>({ alias: 'host' });
  public readonly $showHeader = input(false, { alias: 'showHeader' });
  public readonly $swimlane = input.required<KanbanSwimlane>({ alias: 'swimlane' });

  public onLaneToggle(lane: KanbanSwimlane): void {
    this.$host().onLaneToggle(lane);
  }
}
